import { render, staticRenderFns } from "./BulkBankPayment.vue?vue&type=template&id=5c4f6867&scoped=true"
import script from "./BulkBankPayment.vue?vue&type=script&lang=js"
export * from "./BulkBankPayment.vue?vue&type=script&lang=js"
import style0 from "./BulkBankPayment.vue?vue&type=style&index=0&id=5c4f6867&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f6867",
  null
  
)

export default component.exports